import '../sass/project.scss';

import { initBootstrap } from './bs';
import { initSelect } from './select';
import { initAddRelated } from './addrelated';
import { initAddFormsetRow } from './addformsetrow';

/* Project specific Javascript goes here. */

function initDocument() {
  for (const init of [
    initBootstrap,
    // initColorMode,
    // initMessages,
    // initForms,
    // initQuickSearch,
    initSelect,
    // initDateSelector,
    // initButtons,
    // initClipboard,
    // initTableConfig,
    // initInterfaceTable,
    // initSideNav,
    // initRackElevation,
    // initLinks,
    // initHtmx,
    initAddRelated,
    initAddFormsetRow,
    initWindow,
  ]) {
    init();
  }
}

function initWindow() {
  // const documentForms = document.forms;
  // for (const documentForm of documentForms) {
  //   if (documentForm.method.toUpperCase() == 'GET') {
  //     documentForm.addEventListener('formdata', function (event: FormDataEvent) {
  //       const formData: FormData = event.formData;
  //       for (const [name, value] of Array.from(formData.entries())) {
  //         if (value === '') formData.delete(name);
  //       }
  //     });
  //   }
  // }

  // const contentContainer = document.querySelector < HTMLElement > ('.content-container');
  // if (contentContainer !== null) {
  //   // Focus the content container for accessible navigation.
  //   contentContainer.focus();
  // }
  console.log("InitWindow")
  window.htmx = require('htmx.org');
}


if (document.readyState !== 'loading') {
  initDocument();
} else {
  document.addEventListener('DOMContentLoaded', initDocument);
}


// old stuff

function cloneMore(selector, type) {
  var newElement = $(selector).clone(true);

  var total = parseInt($('#id_' + type + '-TOTAL_FORMS').val());
  var maxForms = parseInt($('#id_' + type + '-MAX_NUM_FORMS').val());

  console.log("There are " + total + " forms and " + maxForms + " max forms");

  if (total < maxForms) {
    newElement.find(':input').each(function () {
      var name = $(this).attr('name').replace('-' + (total - 1) + '-', '-' + total + '-');
      var id = 'id_' + name;
      $(this).attr({ 'name': name, 'id': id }).val('').removeAttr('checked');
    });
    newElement.find('label').each(function () {
      var newFor = $(this).attr('for').replace('-' + (total - 1) + '-', '-' + total + '-');
      $(this).attr('for', newFor);
    });
    total++;

    $('#id_' + type + '-TOTAL_FORMS').val(total);
    $(selector).after(newElement);
  } else {
    console.log("There are too many forms!");
  }
}

function deleteMore(selector, type) {
  var total = parseInt($('#id_' + type + '-TOTAL_FORMS').val());
  var minForms = parseInt($('#id_' + type + '-MIN_NUM_FORMS').val());

  if (total > minForms) {
    console.log("There are " + total + " forms and " + minForms + " min forms");

    $(selector).remove();
    total--;
    $('#id_' + type + '-TOTAL_FORMS').val(total);
  } else {
    console.log("Can't have any less forms!")
  }
}
